export class Combobox {
	constructor( node, opts = {} ) {
		this.node = node;
		this.opts = {
			openClass       : 'combobox--open',
			invertedClass   : 'combobox--inverted',
			multipleText    : '%d items',
			mobileMediaQuery: '(max-width: 600px)',
			...opts
		};

		this.opened = false;

		this.button = this.node.querySelector('.combobox__button');
		this.button.addEventListener('click', this.toggle.bind(this));

		this.buttonText = this.button.querySelector('.combobox__button-text');
		this.buttonText.dataset.textContent = this.buttonText.textContent;

		this.options = this.node.querySelector('.combobox__options');
		this.options.hidden = true;

		this.inputs = this.node.querySelectorAll('input[type="checkbox"]');

		const setButtonText = () => {
			const checkedInputs = this.node.querySelectorAll('input[type="checkbox"]:checked');

			if ( checkedInputs.length > 1 ) {
				this.buttonText.textContent = ( this.buttonText.dataset.multipleText || this.opts.multipleText ).replace(/%d/g, checkedInputs.length);
			} else if ( checkedInputs.length === 1 ) {
				this.buttonText.textContent = checkedInputs[0].parentNode.textContent;
			} else {
				this.buttonText.textContent = this.buttonText.dataset.textContent || 'All';
			}
		}

		this.node.addEventListener('change', setButtonText);
		setButtonText();

		// listen for clicks outside the node and close if outside - but not on mobile
		this.listenForClose = (e) => {
			let node = document.activeElement;

			while( node && node.parentNode ) {
				if ( node === this.node ) {
					return;
				}
				node = node.parentNode;
			}

			this.close();
		}

		// listen for the esc key
		this.listenForEsc = (e) => {
			if ( this.opened && e.key === 'Escape' ) {
				this.close();
			}
		}

		this.node.addEventListener('keydown', ( e ) => {
			if ( document.activeElement.closest('.combobox') === this.node && ['ArrowUp', 'ArrowDown'].includes(e.key) ) {
				if ( ! this.opened ) {
					this.open();
				}

				if ( document.activeElement === this.button ) {
					this.inputs[0].focus();
					return;
				}

				e.preventDefault();

				for ( let i = 0, len = this.inputs.length; i < len; i++ ) {
					if ( document.activeElement === this.inputs[i] ) {
						switch( e.key ) {
							case 'ArrowUp':
								this.inputs[ i <= 0 ? len - 1 : i - 1 ].focus();
								break;
							case 'ArrowDown':
								this.inputs[ i >= len - 1 ? 0 : i + 1 ].focus();
							break;
						}
						break;
					}
				}
			}
		});
	}

	open() {
		const rect = this.node.getBoundingClientRect();
		let   inverted = false;

		if ( rect.top + rect.height > window.innerHeight / 2 ) {
			inverted = true;
			this.node.classList.add( this.opts.invertedClass );
		}

		this.opened = true;
		this.node.classList.add( this.opts.openClass );
		this.options.removeAttribute('hidden');

		if ( inverted ) {
			this.options.style.maxHeight = `${rect.top}px`;
		} else {
			this.options.style.maxHeight = `${window.innerHeight - rect.top - rect.height}px`;
		}

		document.body.addEventListener('click', this.listenForClose);
		document.body.addEventListener('focus', this.listenForClose, true);
		document.addEventListener('keyup', this.listenForEsc);
	}

	close() {
		this.opened = false;
		this.node.classList.remove( this.opts.openClass );
		this.node.classList.remove( this.opts.invertedClass );
		this.options.hidden = true;
		document.body.removeEventListener('click', this.listenForClose);
		document.body.removeEventListener('focus', this.listenForClose, true);
		document.removeEventListener('keyup', this.listenForEsc);
		this.options.removeAttribute('style');
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}
}

export function combobox(selector = '.combobox', opts = {}) {
	return Array.from(document.querySelectorAll(selector)).map(node => new Combobox(node, opts));
}
